import data from './data/data.json';
import marketCap from './data/market-cap.json';

export default function (props) {
  const { initialWidth, initialHeight, isMobile } = props;

  const margins = {
    top: 20,
    right: 15,
    bottom: 20,
    left: 15,
  };

  const width = initialWidth - margins.right - margins.left;
  const height = initialHeight - margins.top - margins.bottom;

  return {
    data,
    marketCap,
    height,
    initialWidth,
    initialHeight,
    isMobile,
    margins,
    width,
  };
}
